import { render } from "./Introduce.vue?vue&type=template&id=28398794&scoped=true&ts=true"
import script from "./Introduce.vue?vue&type=script&lang=ts"
export * from "./Introduce.vue?vue&type=script&lang=ts"

import "./Introduce.vue?vue&type=style&index=0&id=28398794&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28398794"]])

export default __exports__